import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { CloseButton } from "../_components/activity/close-button.component";
import I18 from "../_components/atoms/i18";
import IconMenu2 from "../_components/icon-menu-2.component";
import { NotificationItem } from "../_components/notification-quick-view.component";
import MessageTileShimmer from "../_components/shimmers/message/message-tile-shimmer.component";
import { NotificationService } from "../_service/notification.service";
import { setNotifications } from "../_store/_actions/notification.actions";

export const NOTIFICATION_PAGE_ROUTE = "/notifications";
/**
 * @param {state} setDisplayNotificationPopUp - setter for displayNotificationPopUp
 */

function NotificationPageComponent({
  user,
  notifications,
  setNotifications,
  addToast,
  setDisplayNotificationPopUp,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const newNotificationCount = notifications.filter(
    (n) => !n.isReceived
  ).length;
  const unreadNotificationCount = notifications.filter(
    (n) => !n.isViewed
  ).length;

  // update a notification in state
  const updateNotification = (notification) => {
    const oldNotifications = [...notifications];
    const index = oldNotifications.findIndex((n) => n.id === notification.id);

    if (index > -1) {
      oldNotifications.splice(index, 1, notification);
      setNotifications(oldNotifications);
    }
  };

  // mark notification as received
  useEffect(() => {
    if (newNotificationCount > 0) {
      NotificationService.markNotificationsAsReceived(user, [])
        .then(() => {
          setNotifications(
            notifications.map((notification) => {
              notification.isReceived = true;
              return notification;
            })
          );
        })
        .catch((error) => {
          console.log({ error });
          console.log("could not mark notifications as received", { error });
        });
    }
  }, [newNotificationCount, notifications, user]);

  // load notifications
  useEffect(() => {
    setIsLoading(true);
    NotificationService.getNotifications(user)
      .then(({ notifications }) => {
        setNotifications(notifications);
        setIsLoading(false);
      })
      .catch((error) => {
        addToast("Notifications could not be fetched!", "", ToastTypes.danger);
        setIsLoading(false);
      });
  }, [user]);

  return (
    <>
      <div className="NotificationPage">
        {/* notification list */}
        <div className="notification-dropdown-invalid theme-bg-surface rounded pt-2 shadow">
          <div className="px-3 pb-2 flex items-center justify-between border-b theme-border-default">
            <CloseButton
              onClick={() => setDisplayNotificationPopUp(false)}
              type="primary"
            />
            <span className="font-bold theme-text-subtitle-1">
              🔔 <I18>Notifications</I18>
            </span>
            <IconMenu2
              dropdownClassName="w-52"
              actions={[
                {
                  icon: "check",
                  label: "Mark all viewed",
                  onClick: (e) => {
                    if (
                      unreadNotificationCount > 0 &&
                      notifications.length > 0
                    ) {
                      setIsLoading(true);
                      NotificationService.markNotificationsAsViewed(
                        user,
                        notifications.map((n) => n.id)
                      )
                        .then(({ ids }) => {
                          setNotifications(
                            notifications.map((notification) => {
                              if (ids.includes(notification.id)) {
                                notification.isViewed = true;
                              }
                              return notification;
                            })
                          );
                          setIsLoading(false);
                          addToast(
                            `${unreadNotificationCount} notifications marked as viewed!`,
                            "",
                            ToastTypes.success
                          );
                        })
                        .catch((error) => {
                          setIsLoading(false);
                          console.log(
                            "could not mark notifications as read/viewed",
                            { error }
                          );
                        });
                    }
                  },
                },
              ]}
            />
          </div>
          {/* list items */}
          <div className="notification-list-holder">
            {isLoading && (!notifications || notifications.length === 0) ? (
              <div className="flex flex-col justify-center">
                {/* <Loader /> */}
                {[...Array(12)].map((_, i) => (
                  <div key={i} className="p-1 mx-1">
                    <MessageTileShimmer />
                  </div>
                ))}
              </div>
            ) : notifications.length === 0 ? (
              <div className="flex justify-center">
                <I18>No notification...</I18>
              </div>
            ) : (
              <div className="flex justify-center flex-col">
                {notifications.map((notification) => (
                  <NotificationItem
                    user={user}
                    notification={notification}
                    updateNotification={updateNotification}
                    key={notification.id}
                    addToast={addToast}
                    closeDropDown={() => setDisplayNotificationPopUp(false)}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="secondary-sidebar pr-5"></div>
    </>
  );
}

export const NotificationPage = withToast(
  connect(
    (s) => ({
      user: s.auth,
      notifications: s.notifications,
    }),
    (d) => bindActionCreators({ setNotifications }, d)
  )(NotificationPageComponent)
);
